export enum EventAttendeeStatus {
  INVITED = 'INVITED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  ON_WAITLIST = 'ON_WAITLIST',

  ATTENDING = 'ATTENDING',
  NOT_ATTENDING = 'NOT_ATTENDING',
  MAYBE_ATTENDING = 'MAYBE_ATTENDING',

  // based on checkedIn flag
  CHECKED_IN = 'CHECKED_IN',
}

export namespace EventAttendeeStatus {
  export function getAll() {
    return [
      EventAttendeeStatus.ATTENDING,
      EventAttendeeStatus.NOT_ATTENDING,
      EventAttendeeStatus.MAYBE_ATTENDING,
      EventAttendeeStatus.INVITED,
      EventAttendeeStatus.ON_WAITLIST,
      EventAttendeeStatus.PENDING_APPROVAL,
    ];
  }
  export function getDisplayName(status?: EventAttendeeStatus): string {
    switch (status) {
      case EventAttendeeStatus.ATTENDING:
        return 'APP.MESSAGES.RECIPIENT_GUESTS.YES_GUESTS';
      case EventAttendeeStatus.NOT_ATTENDING:
        return 'APP.MESSAGES.RECIPIENT_GUESTS.NO_GUESTS';
      case EventAttendeeStatus.MAYBE_ATTENDING:
        return 'APP.MESSAGES.RECIPIENT_GUESTS.MAYBE_GUESTS';
      case EventAttendeeStatus.INVITED:
        return 'APP.MESSAGES.RECIPIENT_GUESTS.INVITED_GUESTS';
      case EventAttendeeStatus.ON_WAITLIST:
        return 'APP.MESSAGES.RECIPIENT_GUESTS.WAIT_LIST_GUESTS';
      case EventAttendeeStatus.PENDING_APPROVAL:
        return 'APP.MESSAGES.RECIPIENT_GUESTS.PENDING_GUESTS';
      case EventAttendeeStatus.CHECKED_IN:
        return 'APP.MESSAGES.RECIPIENT_GUESTS.CHECKED_IN_GUESTS';
      default:
        return '';
    }
  }

  export function getRSVPDisplayName(status?: EventAttendeeStatus): string {
    switch (status) {
      case EventAttendeeStatus.ATTENDING:
        return 'APP.RSVP_OPTION.ALL_GOING';
      case EventAttendeeStatus.NOT_ATTENDING:
        return 'APP.RSVP_OPTION.NO';
      case EventAttendeeStatus.MAYBE_ATTENDING:
        return 'APP.RSVP_OPTION.MAYBE';
      case EventAttendeeStatus.INVITED:
        return 'APP.RSVP_OPTION.INVITED';
      case EventAttendeeStatus.ON_WAITLIST:
        return 'APP.RSVP_OPTION.WAITLIST';
      case EventAttendeeStatus.PENDING_APPROVAL:
        return 'APP.RSVP_OPTION.PENDING';
      default:
        return '';
    }
  }

  export function getRSVPIconColor(status?: EventAttendeeStatus): string {
    switch (status) {
      case EventAttendeeStatus.ATTENDING:
        return '#33b977';
      case EventAttendeeStatus.NOT_ATTENDING:
        return '#d72323';
      case EventAttendeeStatus.MAYBE_ATTENDING:
        return '#ffa723';
      case EventAttendeeStatus.INVITED:
        return '#ffe559';
      case EventAttendeeStatus.ON_WAITLIST:
        return '#a9bcc7';
      case EventAttendeeStatus.PENDING_APPROVAL:
        return '#37b8f9';
      default:
        return '';
    }
  }

  export function getAllForMessage() {
    return [
      EventAttendeeStatus.ATTENDING,
      EventAttendeeStatus.NOT_ATTENDING,
      EventAttendeeStatus.MAYBE_ATTENDING,
      EventAttendeeStatus.INVITED,
      EventAttendeeStatus.ON_WAITLIST,
      EventAttendeeStatus.PENDING_APPROVAL,
      EventAttendeeStatus.CHECKED_IN,
    ];
  }
}
